import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import './index.css';
import reportWebVitals from './reportWebVitals';

import MainLayout from "./Layouts/MainLayout";
import FAQ from "./Pages/FAQ";
import Home from "./Pages/Home";
import Testimonials from "./Pages/Testimonials";
import Investment from "./Pages/Investment";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import CancellationPolicy from "./Pages/CancellationPolicy";

const router = createBrowserRouter(
  [
    {
      path: "",
      element: <MainLayout />,
      children: [
        {
          index: true,
          element: <Home />
        },
        {
          path: "testimonials",
          element: <Testimonials />
        },
        {
          path: "investment",
          element: <Investment />
        },
        {
          path: "faqs",
          element: <FAQ />
        },
        {
          path: "privacy-policy",
          element: <PrivacyPolicy />
        },
        {
          path: "cancellation-policy",
          element: <CancellationPolicy />
        },
      ],
    },
    //   Redirect to home?
    { path: "*", element: <div>404 Route</div> },
  ]
);


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <RouterProvider router={router} />
    </HelmetProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
